import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { initGA, trackPageView } from "utils/analytics";
import { initClarity } from "utils/clarity";

export default function AnalyticsTracker() {
  const location = useLocation();

  useEffect(() => {
    initGA();
    initClarity();
  }, []);

  useEffect(() => {
    const path = location.pathname + location.search;
    trackPageView(path);
  }, [location.pathname, location.search]);

  return null;
}